import React, { useEffect, useLayoutEffect } from "react";
import SuccessfulSubmit from "../../../components/cards/SuccessfulSubmit";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../../components/container/MainContainer";
import { CircleCheckBigIcon, CircleX } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProject } from "../../../features/projectsSlice";
import Loading from "../../../components/loading/Loading";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const CommunityProposalSubmitState = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.userInfo);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);

  useEffect(() => {
    if (!project.id) {
      dispatch(getProject(id));
    }
  }, [project]);

  useLayoutEffect(() => {
    if (
      (id && project.id && project.stage.step_number < 8) ||
      (id && project.id && project.stage.step_number > 10)
    ) {
      return navigate("/requests/community-approvals");
    }
  }, [project, user]);

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      {project.id &&
        (project.status.toLowerCase() === "canceled" ? (
          <SuccessfulSubmit
            message={`You have cancelled the project Successfully`}
            icon={CircleX}
            link="/requests/community-approvals"
            linkName="Go to Community Approvals"
            red
          />
        ) : (
          <SuccessfulSubmit
            message={`Community Proposal has been successfuly submitted to the ${project.province.slice(
              0,
              -1
            )}ial  Council`}
            icon={CircleCheckBigIcon}
            link="/requests/community-approvals"
            linkName="Go to Community Approvals"
          />
        ))}
    </MainContainer>
  );
};

export default CommunityProposalSubmitState;
